export class ShowMore {
  static isOnPage() {
    return $('.js-show-more-container').length !== 0;
  }

  constructor() {
    this.inited = false;
    this.items = [];
    this.init();
    $(window).on('resize', () => this.onResize());
  }

  onResize() {
    this.init();
  }

  onButtonClick(index, $content, $button) {
    const item = this.items[index];
    const itemActive = !item.active;
    const newHeight = itemActive ? item.fullHeight : item.collapsedHeight;

    $content.animate({ height: newHeight }, 'fast');
    $button.toggleClass('slideHide-show', itemActive);
    $button.attr('aria-expanded', String(itemActive));
    $content.attr('aria-hidden', String(!itemActive));

    this.items[index].active = itemActive;
  }

  // Returns the CSS height (in px) needed to show exactly rowCount lines of text,
  // or null if the content has rowCount or fewer lines (no clipping needed).
  //
  // Instead of guessing lineHeight from CSS (which differs per brand, element type,
  // and whether content has <p>/<ul> wrappers or bare text), we ask the browser
  // directly: call getClientRects() on every text node — it returns one rect per
  // visual line. We group rects by their top position, sort them, and read the
  // bottom coordinate of the Nth line. No arithmetic, no CSS variables involved.
  getCollapsedHeight(el, rowCount) {
    const lines = [];

    const walk = (node) => {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim().length > 0) {
        const range = document.createRange();
        range.selectNode(node);

        for (const rect of range.getClientRects()) {
          if (rect.width === 0 || rect.height === 0) {
            continue;
          }

          const existing = lines.find((line) => Math.abs(line.top - rect.top) < 2);

          if (existing) {
            existing.bottom = Math.max(existing.bottom, rect.bottom);
          } else {
            lines.push({ top: rect.top, bottom: rect.bottom });
          }
        }
      }

      for (const child of node.childNodes) {
        walk(child);
      }
    };

    walk(el);
    lines.sort((lineA, lineB) => lineA.top - lineB.top);

    if (lines.length <= rowCount) {
      return null;
    }

    const elTop = el.getBoundingClientRect().top;

    return lines[rowCount - 1].bottom - elTop;
  }

  toggle(index, container) {
    const $container = $(container);
    const $content = $container.find('.js-show-more-content');
    const $button = $container.find('.js-show-more-toggle');

    $button.attr('aria-expanded', 'false');
    $content.css('height', 'auto');
    const fullHeight = $content[0].scrollHeight;

    const rowCount = $container.data('row-count') || 5;
    const collapsedHeight = this.getCollapsedHeight($content[0], rowCount);

    const needsToggle = collapsedHeight !== null;

    this.items[index] = {
      active: false,
      fullHeight,
      collapsedHeight
    };

    if (needsToggle) {
      $content.height(collapsedHeight);
      $content.addClass('ContentSlide');
      $button.parents('.Button--AccordionWrap').addClass('u-display-block');
      $content.attr('aria-hidden', 'true');

      if (!this.inited) {
        $button.on('click', () => this.onButtonClick(index, $content, $button));
      }
    } else {
      $content.removeClass('ContentSlide');
      $button.parents('.Button--AccordionWrap').remove();
    }
  }

  init() {
    $.each($('.js-show-more-container'), (index, container) => this.toggle(index, container));
    this.inited = true;
  }
}
